





























import { Component, Vue, Prop } from "vue-property-decorator";
import { SectionModel } from "@../../../src/Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";

@Component(
	{
		name: "SectionForm",
		components: { ButtonList }
	})
export default class SectionForm extends ParticaBaseForm<SectionModel> {

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 0, } as FormFieldRules
		} as IFormField;

	private colorconfig =
		{
			props: { name: "color", placeholder: "Enter color", label: "Color in Viewer", } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private orderconfig =
		{
			props: { name: "order", placeholder: "Enter order", label: "Order in Viewer", } as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

}
